export default __webpack_public_path__ + "static/media/sort-arrow-down-active.dbd477b9.svg";